/** @file leafLengths: how far each node's drawn image reaches past its joint along the bone, in units. */
import type { FacetPick } from '@zilo/pose3d-facet/contract';
import { extentPx } from './extentPx';

/**
 * Per node `0..n-1`, the longest reach of its drawn (not hidden, not missing) impostors past the joint, in world units
 * (`pixelsPerUnit` = the authored pixels per unit); 0 for a node that draws nothing. `nodeOf` maps a pick's drawable
 * id to its node index (-1 = none). Writes `out` in place (no allocation) and returns it.
 */
export function leafLengths(picks: readonly FacetPick[], nodeOf: (drawable: string) => number, pixelsPerUnit: number, n: number, out: Float64Array): Float64Array {
  out.fill(0, 0, n);
  for (const pick of picks) {
    if (pick.hidden || pick.missing) continue;
    const i = nodeOf(pick.drawable);
    if (i < 0 || i >= n) continue;
    const units = extentPx(pick) / pixelsPerUnit;
    if (units > (out[i] ?? 0)) out[i] = units;
  }
  return out;
}
